<template>
  <aside class="dbs" v-click-outside="closeSubmenu">
    <!-- Logo -->
    <div class="dbs-logo">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" role="img" aria-label="VSLBooster">
        <path d="M 10 62 A 30 30 0 0 1 70 62" fill="none" stroke="#E86A10" stroke-width="5" stroke-linecap="round"/>
        <path d="M 10 62 A 30 30 0 0 1 44 34" fill="none" stroke="#F5B935" stroke-width="5" stroke-linecap="round"/>
        <path d="M 40 62 L 54 28 L 58 32 Z" fill="#FFFFFF"/>
        <circle cx="40" cy="62" r="3.5" fill="#FFFFFF"/>
        <circle cx="40" cy="62" r="1.5" fill="#0A0D12"/>
      </svg>
    </div>

    <!-- Nav -->
    <nav class="dbs-nav">
      <div
        v-for="item in items"
        :key="item.name"
        class="dbs-item-wrap"
      >
        <button
          class="dbs-item"
          :class="{ active: item.active || activeSubmenu === item.name }"
          :title="item.label"
          @click="handleClick(item, $event)"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
            <path :d="item.icon" />
          </svg>
          <span v-if="item.badge" class="dbs-badge"></span>
          <span v-if="item.children" class="dbs-chevron">
            <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <path d="M9 18l6-6-6-6"/>
            </svg>
          </span>
        </button>

        <!-- Submenu flyout -->
        <transition name="dbs-fly">
          <div
            v-if="item.children && activeSubmenu === item.name"
            class="dbs-submenu"
            :style="{ top: submenuTop + 'px' }"
          >
            <div class="dbs-submenu__header">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#E86A10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path :d="item.icon" />
              </svg>
              <span>{{ item.label }}</span>
            </div>
            <div class="dbs-submenu__list">
              <button
                v-for="child in item.children"
                :key="child.route"
                class="dbs-submenu__item"
                :class="{ active: $route && $route.name === child.route }"
                @click="navigateTo(child)"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path :d="child.icon" />
                </svg>
                <span>{{ child.label }}</span>
              </button>
            </div>
          </div>
        </transition>
      </div>
    </nav>

    <!-- Avatar -->
    <div class="dbs-foot">
      <button class="dbs-help" title="Agendar sessão de dúvidas" @click="openScheduleModal">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          <path d="M8 10h8M8 7h8" />
        </svg>
      </button>

      <button class="dbs-avatar" :title="`Abrir perfil de ${userName}`" @click="toggleProfileMenu">
        <img v-if="avatarUrl" :src="avatarUrl" :alt="userName" class="dbs-avatar-img">
        <span v-else>{{ initials }}</span>
        <span class="dbs-dot"></span>
      </button>
      <transition name="dbs-fly">
        <div v-if="profileMenuOpen" class="dbs-profile-menu">
          <button class="dbs-profile-menu__item" @click="goToProfile">
            <span>Perfil</span>
          </button>
          <button class="dbs-profile-menu__item dbs-profile-menu__item--danger" @click="logout">
            <span>Sair</span>
          </button>
        </div>
      </transition>
    </div>

    <transition name="dbs-fly">
      <div v-if="scheduleModalOpen" class="dbs-modal-overlay" @click.self="closeScheduleModal">
        <div class="dbs-modal">
          <div class="dbs-modal__header">
            <div>
              <h4>Sessão de dúvidas (30 minutos)</h4>
              <p>Escolha o melhor horário para você.</p>
            </div>
            <button class="dbs-modal__close" @click="closeScheduleModal">✕</button>
          </div>
          <div class="dbs-modal__body">
            <iframe
              class="dbs-modal__frame"
              src="https://iaqfaz.com.br/agendar/vsl-booster-5yxe/consultoria-vsl-booster"
              title="Agendamento consultoria VSL Booster"
              frameborder="0"
            />
          </div>
        </div>
      </div>
    </transition>
  </aside>
</template>

<script>
const NAV = [
  { name: 'dashboard',   label: 'Dashboard',    icon: 'M3 3h7v7H3zM14 3h7v7h-7zM14 14h7v7h-7zM3 14h7v7H3z',                                                                                                                                                                                                                                                                                                                                                                                   active: true, route: 'DashboardChat' },
  { name: 'videos',      label: 'VSLs',         icon: 'M2 7a2 2 0 012-2h12a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V7zm18-1l4 3v6l-4 3V6z',                                                                                                                                                                                                                                                                                                                                                badge: true, route: 'Meus-Videos' },
  { name: 'chat',        label: 'Chat Booster', icon: 'M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z',                                                                                                                                                                                                                                                                                                                                                                             route: 'chats' },
  { name: 'leads',       label: 'Leads',        icon: 'M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75',                                                                                                                                                                                                                                                                                                              route: 'leads' },
  { name: 'integracoes', label: 'Integrações',  icon: 'M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71',                                                                                                                                                                                                                                                                                                                  route: 'integracoes' },
  { name: 'webinar',     label: 'Webinário',    icon: 'M12 2a10 10 0 100 20A10 10 0 0012 2zm0 4a6 6 0 110 12A6 6 0 0112 6zm0 4a2 2 0 100 4 2 2 0 000-4z',                                                                                                                                                                                                                                                                                                                                     route: 'webinar-simulator' },
  { name: 'academia',    label: 'Minha Academia', icon: 'M12 3L2 8l10 5 10-5-10-5zM6 10.5V17c0 1.7 2.7 3 6 3s6-1.3 6-3v-6.5M20 8v6', route: 'minha-academia' },
  { name: 'heatmap',     label: 'Heatmap',      icon: 'M22 12h-4l-3 9L9 3l-3 9H2',                                                                                                                                                                                                                                                                                                                                                                                                            route: 'heatmap' },
  { name: 'pixels',      label: 'Pixels',       icon: 'M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82zM7 7h.01',                                                                                                                                                                                                                                                                                                                                                 route: 'Meus-Videos' },
  {
    name: 'config',
    label: 'Administração',
    superAdminOnly: true,
    icon: 'M12 15a3 3 0 100-6 3 3 0 000 6zM19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z',
    children: [
      { label: 'Dashboard',          route: 'admin-overview',       icon: 'M3 3h7v7H3zM14 3h7v7h-7zM14 14h7v7h-7zM3 14h7v7H3z' },
      { label: 'Observabilidade',    route: 'admin-observabilidade', icon: 'M22 12h-4l-3 9L9 3l-3 9H2' },
      { label: 'Usuários & Clientes',route: 'admin-usuarios',        icon: 'M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8z' },
      { label: 'Treinamentos',       route: 'app-treinamentos',      icon: 'M12 3L2 8l10 5 10-5-10-5zM6 10.5V17c0 1.7 2.7 3 6 3s6-1.3 6-3v-6.5M20 8v6' },
      { label: 'Blog',               route: 'admin-blog',            icon: 'M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8zM14 2v6h6M16 13H8M16 17H8M10 9H8' },
      { label: 'Uso de IA',          route: 'admin-ai-usage',        icon: 'M12 2a10 10 0 100 20A10 10 0 0012 2zM8 12h8M12 8v8' },
      { label: 'Configurações',      route: 'admin-configuracoes',   icon: 'M12 15a3 3 0 100-6 3 3 0 000 6zM19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z' },
    ],
  },
]

const SUPER_ADMIN_EMAIL = 'edvomberto@gmail.com'

function isSuperAdmin() {
  try {
    const u = JSON.parse(localStorage.getItem('userData') || '{}')
    const email = (u.user_email || u.email || '').toLowerCase()
    return email === SUPER_ADMIN_EMAIL
  } catch { return false }
}

export default {
  name: 'DashSidebar',
  directives: {
    clickOutside: {
      bind(el, binding) {
        el.__clickOutside__ = (e) => {
          if (!el.contains(e.target)) binding.value(e)
        }
        document.addEventListener('click', el.__clickOutside__)
      },
      unbind(el) {
        document.removeEventListener('click', el.__clickOutside__)
      },
    },
  },
  props: {
    userName: { type: String, default: 'Eduardo' },
  },
  data() {
    return {
      items: NAV.filter(n => !n.superAdminOnly || isSuperAdmin()).map(n => ({ ...n, active: false })),
      activeSubmenu: null,
      submenuTop: 0,
      avatarUrl: '',
      profileMenuOpen: false,
      scheduleModalOpen: false,
    }
  },
  computed: {
    initials() {
      return this.userName.split(' ').map(w => w[0]).slice(0, 2).join('').toUpperCase()
    },
  },
  mounted() {
    this.syncActiveRoute()
    this.syncUserAvatar()
  },
  watch: {
    $route() {
      this.syncActiveRoute()
      this.activeSubmenu = null
      this.syncUserAvatar()
    },
  },
  methods: {
    computeSubmenuTop(btnRect, item) {
      const viewportTopPadding = 10
      const viewportBottomPadding = 10
      const headerHeight = 48
      const rowHeight = 38
      const listPadding = 12
      const estimatedHeight = headerHeight + ((item.children || []).length * rowHeight) + listPadding
      const maxTop = window.innerHeight - estimatedHeight - viewportBottomPadding
      return Math.max(viewportTopPadding, Math.min(btnRect.top, maxTop))
    },
    syncUserAvatar() {
      try {
        const user = JSON.parse(localStorage.getItem('userData') || '{}')
        this.avatarUrl = user.user_photo_url || user.avatar || ''
      } catch (_) {
        this.avatarUrl = ''
      }
    },
    syncActiveRoute() {
      const name = this.$route && this.$route.name
      this.items.forEach(i => {
        if (i.children) {
          i.active = i.children.some(c => c.route === name)
        } else {
          i.active = (i.route === name)
        }
      })
    },
    handleClick(item, event) {
      if (item.children) {
        if (this.activeSubmenu === item.name) {
          this.activeSubmenu = null
        } else {
          const btn = event.currentTarget
          const rect = btn.getBoundingClientRect()
          this.submenuTop = this.computeSubmenuTop(rect, item)
          this.activeSubmenu = item.name
        }
      } else {
        this.activeSubmenu = null
        this.items.forEach(i => { i.active = false })
        item.active = true
        if (item.route) this.$router.push({ name: item.route }).catch(() => {})
      }
    },
    navigateTo(child) {
      this.activeSubmenu = null
      this.$router.push({ name: child.route }).catch(() => {})
    },
    closeSubmenu() {
      this.activeSubmenu = null
      this.profileMenuOpen = false
    },
    toggleProfileMenu() {
      this.activeSubmenu = null
      this.scheduleModalOpen = false
      this.profileMenuOpen = !this.profileMenuOpen
    },
    openScheduleModal() {
      this.activeSubmenu = null
      this.profileMenuOpen = false
      this.scheduleModalOpen = true
    },
    closeScheduleModal() {
      this.scheduleModalOpen = false
    },
    goToProfile() {
      this.profileMenuOpen = false
      this.activeSubmenu = null
      this.$router.push({ name: 'perfil_usuario' }).catch(() => {})
    },
    logout() {
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('token')
      localStorage.removeItem('userData')
      localStorage.removeItem('lgn_admin')
      localStorage.removeItem('lgn_admin_metadata')
      this.profileMenuOpen = false
      this.$router.push({ name: 'auth-login' }).catch(() => {})
    },
  },
}
</script>

<style>
.dbs {
  width: 64px;
  height: 100%;
  background: #0D1117;
  border-right: 1px solid rgba(255,255,255,.06);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 14px 0;
  overflow: visible;
  position: relative;
  z-index: 100;
  flex-shrink: 0;
}
.dbs-logo {
  width: 40px;
  height: 40px;
  border-radius: 11px;
  background: linear-gradient(135deg, #1a1f2e, #0f1420);
  border: 1px solid rgba(232,106,16,.25);
  box-shadow: 0 6px 18px -4px rgba(232,106,16,.3);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  flex-shrink: 0;
  padding: 5px;
}
.dbs-logo svg { width: 30px; height: 30px; }
.dbs-nav {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  width: 100%;
  padding: 0 8px;
  overflow-y: auto;
  overflow-x: visible;
}
.dbs-item-wrap {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
}
.dbs-item {
  position: relative;
  width: 44px;
  height: 44px;
  border-radius: 11px;
  border: none;
  background: transparent;
  color: rgba(255,255,255,.3);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background .15s, color .15s;
  flex-shrink: 0;
}
.dbs-item:hover { background: rgba(255,255,255,.06); color: rgba(255,255,255,.75); }
.dbs-item.active { background: rgba(255,255,255,.09); color: #fff; }
.dbs-badge {
  position: absolute;
  top: 9px;
  right: 9px;
  width: 7px;
  height: 7px;
  background: #E86A10;
  border-radius: 50%;
  border: 1.5px solid #0D1117;
}
.dbs-chevron {
  position: absolute;
  bottom: 5px;
  right: 5px;
  opacity: .35;
  display: flex;
}

/* ── Submenu flyout ─────────────────────────────────── */
.dbs-submenu {
  position: fixed;
  left: 74px;
  width: 200px;
  max-height: calc(100vh - 20px);
  background: #141b27;
  border: 1px solid rgba(255,255,255,.08);
  border-radius: 14px;
  box-shadow: 0 12px 40px rgba(0,0,0,.5), 0 0 0 1px rgba(255,255,255,.04);
  overflow: hidden;
  z-index: 9999;
}
.dbs-submenu__header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 14px 10px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .07em;
  text-transform: uppercase;
  color: rgba(255,255,255,.4);
  border-bottom: 1px solid rgba(255,255,255,.06);
}
.dbs-submenu__list {
  padding: 6px;
  max-height: calc(100vh - 84px);
  overflow-y: auto;
}
.dbs-submenu__item {
  display: flex;
  align-items: center;
  gap: 9px;
  width: 100%;
  padding: 9px 10px;
  border: none;
  background: transparent;
  color: rgba(255,255,255,.6);
  font-size: 13px;
  font-weight: 500;
  font-family: 'Inter', sans-serif;
  border-radius: 9px;
  cursor: pointer;
  text-align: left;
  transition: background .13s, color .13s;
}
.dbs-submenu__item:hover {
  background: rgba(255,255,255,.07);
  color: #e2e8f0;
}
.dbs-submenu__item.active {
  background: rgba(232,106,16,.12);
  color: #E86A10;
}
.dbs-submenu__item svg { flex-shrink: 0; opacity: .7; }
.dbs-submenu__item.active svg { opacity: 1; }

/* ── Flyout animation ───────────────────────────────── */
.dbs-fly-enter-active,
.dbs-fly-leave-active {
  transition: opacity .15s, transform .15s;
}
.dbs-fly-enter,
.dbs-fly-leave-to {
  opacity: 0;
  transform: translateX(-6px);
}

.dbs-foot { margin-top: auto; padding-top: 12px; }
.dbs-help {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  border: 1px solid rgba(45, 212, 191, 0.35);
  background: linear-gradient(135deg, rgba(20, 184, 166, 0.35), rgba(16, 185, 129, 0.28));
  color: #5eead4;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  transition: transform .15s, filter .15s;
}
.dbs-help:hover {
  transform: translateY(-1px);
  filter: brightness(1.08);
}
.dbs-profile-menu {
  position: absolute;
  left: 74px;
  bottom: 8px;
  width: 150px;
  background: #141b27;
  border: 1px solid rgba(255,255,255,.1);
  border-radius: 10px;
  box-shadow: 0 12px 30px rgba(0,0,0,.45);
  overflow: hidden;
  z-index: 9999;
}
.dbs-profile-menu__item {
  width: 100%;
  border: none;
  background: transparent;
  color: rgba(255,255,255,.72);
  font-size: 13px;
  font-weight: 600;
  text-align: left;
  padding: 10px 12px;
  cursor: pointer;
}
.dbs-profile-menu__item:hover {
  background: rgba(255,255,255,.08);
  color: #fff;
}
.dbs-profile-menu__item--danger {
  color: #f87171;
}
.dbs-profile-menu__item--danger:hover {
  background: rgba(248,113,113,.12);
  color: #fca5a5;
}

.dbs-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(5, 8, 14, 0.72);
  backdrop-filter: blur(2px);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
}
.dbs-modal {
  width: min(980px, 96vw);
  height: min(760px, 92vh);
  border-radius: 14px;
  overflow: hidden;
  background: #0f1624;
  border: 1px solid rgba(255,255,255,0.1);
  box-shadow: 0 24px 60px rgba(0,0,0,0.5);
  display: flex;
  flex-direction: column;
}
.dbs-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 16px;
  border-bottom: 1px solid rgba(255,255,255,0.08);
  background: rgba(255,255,255,0.03);
}
.dbs-modal__header h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 800;
  color: #f8fafc;
}
.dbs-modal__header p {
  margin: 4px 0 0;
  font-size: 12px;
  color: rgba(255,255,255,0.55);
}
.dbs-modal__close {
  border: none;
  background: none;
  color: rgba(255,255,255,0.65);
  font-size: 18px;
  cursor: pointer;
  line-height: 1;
}
.dbs-modal__body {
  flex: 1;
  min-height: 0;
}
.dbs-modal__frame {
  width: 100%;
  height: 100%;
  border: none;
  background: #fff;
}
.dbs-avatar {
  position: relative;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #8B5CF6, #EC4899);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  overflow: hidden;
}
.dbs-avatar-img {
  width: 100% !important;
  height: 100% !important;
  display: block;
  border-radius: 50%;
  object-fit: contain !important;
  object-position: center center !important;
  background: #111827;
}
.dbs-dot {
  position: absolute;
  bottom: 1px;
  right: 1px;
  width: 9px;
  height: 9px;
  background: #28C76F;
  border-radius: 50%;
  border: 2px solid #0D1117;
}
</style>
